import React, { Fragment } from "react"
import './register.scss'

// import { Link } from 'react-router-dom'

import Navbar from '../../components/newNavbar/navbar'
import Button from '../../components/newButton/button'
import Loading from '../../components/loading/loading'
// import ButtonText from '../../components/buttonText/buttonText'
import Input from '../../components/newInput/input'
import ImgPage from '../../components/imgPage/imgPage'
import { Mutation } from 'react-apollo'
import { CreateUser } from '../../queries/player'
import ErrorM from '../../components/ErrorMessange/errormenssage'
import { GraphQLClient } from 'graphql-request'
import { endpoint } from '../../queries/endpoint'
import Simplert from 'react-simplert'
import * as emailjs from 'emailjs-com'
import PasswordMeter from '../../components/PassworMeter/passwordmeter'
import ErrorBroundray from '../../components/errorBoundary/errorBoundary'
import ReactPixel from 'react-facebook-pixel';

export default class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitOK: false,
            showAlert: false,
            loading: false,
            typeAlert: '',
            titleAlert: '',
            messageAlert: '',
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot', // colocar cor roxa
            onClose: null,
            nameok: false,
            emailok: false,
            termo: false,
            passwordok: false,
            spinneremail: false,
            nameErr: null,
            emailErr: null,
            passwordErr: null,
            phoneErr: null,
            phoneOk: false,
            termoErr: null
        }

        

        this.form = {}

        const options = {
            autoConfig: true, 	// set pixel's autoConfig
            debug: false, 		// enable logs
        };
        ReactPixel.init('1245215422327975', options);

        this.setInput = event => {
            this.form[`${event.target.name}`] = event.target.value
            return event.target.value
        } //_setInput

        this.blurName = (e) => {
            this.setState({ showAlert: false })
            if (this.form.name) {
                if (this.form.name.length >= 5 && this.form.name.includes(' ')) {
                    this.setState({ nameok: true, nameErr: null })
                } else {
                    this.setState({
                        nameErr: <ErrorM content='Por favor, digite seu nome completo.' />,
                        nameok: false
                    })
                }
            } else {
                this.setState({
                    nameErr: null,
                    nameok: false
                })
            }
        }

        this.phoneMask = e => {
            // const onlyNumbers = value => value.replace(/(^-{1})|(\d)|(\D)/g, "$1$2");
            let phoneMasked = e.target.value;
            // if (!onlyNumbers(phoneMasked) || phoneMasked.length > 9) return phoneMasked;
            //Adiciona "()" no DDD e um "espaço"
            // phoneMasked = phoneMasked.replace(/^(\d{2})(\d)/g, "($1) $2");
            //Adiciona o separador "-" entre os digitos tanto em telefones com 9 ou 8 dígitos
            // phoneMasked = phoneMasked.replace(/(\d{5,})(\d{4})$/, "$1-$2");
            //Retorna a máscara
            this.form['phone'] = phoneMasked
            if (phoneMasked.length === 15) this.setState({ phoneOk: true, phoneErr: null })
            else this.setState({ phoneOk: false, phoneErr: <ErrorM content='Por favor, digite seu numero de celular.' /> })
            return (e.target.value = phoneMasked);
        }; //_phoneMask

        this.blurEmail = () => {
            this.setState({ showAlert: false, emailErr: null })
            if (this.form.email) {
                if (this.form.email.includes('@') && this.form.email.split("@")[1].includes('.')) {
                    const emailValid = this.form.email.split(" ")[0]
                    this.form.email = emailValid
                    // this.setState({ spinneremail: true })

                    const client = new GraphQLClient(endpoint)

                    client.request(`
                        {
                            allUsers(filter: {
                            email: "${emailValid.toString()}"
                            }){
                            id
                            email
                            name
                            document
                            }
                        }
                  `).then(
                        res => {
                            // console.log(res)
                            if (res.allUsers.length > 0) {
                                this.setState({
                                    emailErr: <ErrorM content='E-mail já cadastrado.' />,
                                    emailok: false,
                                })
                            } else {
                                this.setState({ emailok: true, emailErr: null })
                            }
                        }
                    )
                } else {
                    this.setState({
                        emailErr: <ErrorM content='E-mail inválido. Por favor digite novamente. Ex.: jose@email.com' />,
                        emailok: false,
                    })
                }
            }
        }

        this.blurPassword = () => {
            this.setState({ showAlert: false, passwordErr: null, passwordok: false })
            var regex = /^(?=(?:.*?[0-9]){2})(?=(?:.*?[a-zA-Z]){2})(?!.*\s)[0-9a-zA-Z!@#$%;*(){}_+^&]*$/;

            if (this.form.password) {
                if (this.form.password.length >= 8) {
                    if (regex.exec(this.form.password)) {
                        this.setState({ passwordok: true, passwordErr: null })
                    } else {
                        this.setState({
                            passwordok: false,
                            passwordErr: <ErrorM content='A senha deve ter, no mínimo, 2 números e 2 letras.' />
                        })
                    }
                } else {
                    this.setState({
                        passwordok: false,
                        passwordErr: <ErrorM content='A senha deve ter, no mínimo, 8 caracteres.' />
                    })
                }
            }
        }

        this.sendRegister = (CreateUser, e) => {

            this.setState({ showAlert: false, loading: true })

            e.preventDefault()

            if (this.state.nameok && this.state.emailok && this.state.passwordok && this.state.phoneOk && this.state.termo) {
                // if (this.state.nameok && this.state.emailok && this.state.passwordok) {
                // const data = {
                //     email: this.form.email.toString(),
                //     name: this.form.name.toString(),
                //     phone: this.form.phone.toString(),
                // }

                // ReactPixel.track( "CompleteRegistration", data )

                const emailValid = this.form.email.split(" ")[0]
                this.form.email = emailValid

                CreateUser({
                    variables: {
                        email: this.form.email.toString(),
                        password: this.form.password.toString(),
                        name: this.form.name.toString(),
                        phone: this.form.phone.toString(),
                    }
                }).then(
                    res => {
                        const userAuth = {
                            token: res.data.authUser.token,
                            user: res.data.authUser.user
                        }

                        this.setState({ playerId: res.data.authUser.user.id })

                        sessionStorage.setItem('OITO', JSON.stringify(userAuth))

                        //enviar email
                        var template_params = {
                            "email": res.data.createUser.email,
                            "name": res.data.createUser.name,
                        }

                        emailjs.send('noreply', 'bemvindo', template_params, "user_IagwdTtEr3AVRdLhxkyKc")
                            .then((response) => {
                                console.log('SUCCESS!', response.status, response.text)
                                this.form = {}
                            }, function (error) {
                                console.log('FAILED...', error)
                            });

                        //enviar modal de confirmacao
                        //trocar por alert ----------------------------------------------------------------------------------------------------------------
                        this.setState({
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Cadastro atualizado com sucesso!',
                            messageAlert: 'Feche este aviso para continuar',
                            onClose: () => window.location.href = "/verificartelefone?sucesso",
                            submitOK: false,
                            loading: false
                        })
                    }
                ).catch(err => {
                    console.log(err)
                    return <p>Algo de errado aconteceu. Tente novamente.</p>
                })
            } else {
                if (!this.state.nameok) this.setState({
                    nameErr: <ErrorM content='Por favor, digite seu nome completo.' />,
                })
                if (!this.state.emailok) this.setState({
                    emailErr: <ErrorM content='Por favor, digite um e-mail válido e que não tenha sido usado.' />,
                })
                if (!this.state.passwordok) this.setState({
                    passwordErr: <ErrorM content='A senha deve ter, no mínimo, 2 números, 2 letras e 8 caracteries.' />,
                })
                if (!this.state.phoneOk) this.setState({
                    phoneErr: <ErrorM content='Por favor, numero de celular valido e que não tenha sido usado.' />,
                })
                if (!this.state.termo) this.setState({
                    termoErr: <ErrorM content='É obrigátorio aceitar os termos de uso.' />,
                })
            }
        } //enviar cadastro
    }

    render() {
        const LastURL = JSON.parse(sessionStorage.getItem('LastURL'))
        // console.log(sessionStorage.getItem('LastURL'))
        if (LastURL) {
            if (LastURL.path !== window.location.pathname) {
                const listHistory = {
                    count: parseInt(LastURL.count) - 1,
                    path: window.location.pathname
                }
                sessionStorage.setItem('LastURL', JSON.stringify(listHistory))
            }
        }

        const cache = JSON.parse(sessionStorage.getItem('OITO'))
        if (cache) {
            window.location.href = "/perfil"
        }
        
        return (
            <Fragment>
                <ErrorBroundray><Navbar /></ErrorBroundray>
                <ErrorBroundray><ImgPage>

                    <Simplert
                        showSimplert={this.state.showAlert}
                        type={this.state.typeAlert}
                        title={this.state.titleAlert}
                        message={this.state.messageAlert}
                        customCloseBtnText={this.state.customCloseBtnText}
                        customCloseBtnClass={this.state.customCloseBtnClass}
                        onClose={this.state.onClose}
                    />

                    <div className={'register-div col-xs-12'}>
                    <div className="row center-xs middle-xs">
                        <div className="col-xs-12">
                            <h1>Cadastre-se</h1>
                            {/*<span>/algum texto/</span>*/}
                        </div>
                        <div className="col-xs-12" style={{ marginBottom: "50px"}}>
                           <form>
                            <Input name={'name'} placeholder={'Nome completo'} type={'text'} onInput={this.setInput} onBlur={this.blurName} required={true} />
                            {this.state.nameErr}
                            <Input name={'phone'} placeholder={'Celular'} mask="(99) 99999-9999" type={'phone'} onInput={this.setInput} onBlur={this.blur} onChange={this.phoneMask} required minlength={15} />
                            {this.state.phoneErr}
                            <Input name={'email'} placeholder={'E-mail'} type={'email'} onInput={this.setInput} onBlur={this.blurEmail} required={true} />
                            {this.state.emailErr}
                            <Input name={'password'} isPassword={true} placeholder={'Senha'} type={'password'} onChange={this.setInput} required={true} minlength={8} onKeyUp={this.blurPassword} />
                            <PasswordMeter password={this.form.password} />
                            {this.state.passwordErr}
                            <div style={{ textAlign: 'center', marginBottom: 15, marginTop: 15 }}>
                                <input type="checkbox" style={{ width: 'auto' }} name="termos" onClick={(e) => this.setState({ termo: e.target.checked, termoErr: null })} required={true} />
                                Aceito os <a href="/termosUso" target="_blank">Termos de uso</a>
                            </div>
                            {this.state.termoErr}
                            {(this.state.nameok && this.state.emailok && this.state.passwordok && this.state.phoneOk)? <ErrorM content='É obrigatório aceitar os termos de uso.' /> : null}

                            <div>
                                <Mutation mutation={CreateUser}>
                                    {(CreateUser, { loading }) => {
                                        if (loading) return <Loading />
                                        return <Button type='submit' name={'prosseguir'} disabled={(this.state.nameok && this.state.emailok && this.state.passwordok && this.state.phoneOk && this.state.termo)? false : true } onClick={(e) => this.sendRegister(CreateUser, e)} />
                                    }}
                                </Mutation>
                            </div>
                        </form> 
                        </div>
                        </div>
                    </div>
                </ImgPage></ErrorBroundray>
            </Fragment>
        )
    }
}
